import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Checkbox, Icon, Label } from 'semantic-ui-react';
import { uniqueKey } from '../../../common/keys';

const UpDownLabel = (props) => {

  const { propKey, handleChange, buttonSize, formData, float, asCheckbox } = props

  const [currentValue, setCurrentValue] = useState(); // Initialize state

  useEffect(() => {
    if (formData) {
      const _value = formData[propKey]
      setCurrentValue(_value)
    }
  }, [formData]);

  useEffect(() => {
    if (currentValue !== undefined && currentValue !== formData?.[propKey]) {
      handleChange(propKey, currentValue);
    }
  }, [currentValue, propKey, formData]);

  const handleUp = () => setCurrentValue(prev => prev + 1);
  const handleDown = () => setCurrentValue(prev => Math.max(prev - 1, 0));
  const handleValue = (checked) => setCurrentValue(!checked)

  const content = () => {
    if (asCheckbox) {
      return <div>
        <Checkbox
          checked={currentValue}
          onChange={() => handleValue(currentValue)}
        />
      </div>
    } else {
      return <div>
        <Icon disabled={currentValue <= 0} name="arrow down" link onClick={handleDown} style={{ margin: 0 }} />
        <Label size={buttonSize} color={currentValue === 0 ? 'grey' : 'blue'}>{currentValue}</Label>
        <Icon name="arrow up" link onClick={handleUp} style={{ margin: 0 }} />
      </div >
    }
  }

  let cn = 'up-down-label'
  if (asCheckbox) { cn += ' cb' }

  return (
    <div key={uniqueKey('udl', propKey)} color='black' size={buttonSize} className={cn} style={{ float: float ? float : 'right' }}>
      {propKey && <div >{_.startCase(propKey)}</div>}
      {content()}
    </div>
  );
};

export default UpDownLabel